import type { LangCode } from '@/lib/i18n/lang';
import { isLangCode } from '@/lib/i18n/lang';

/** Resolves marketing locale from URL (/sr/..., /en/...) for nav links; defaults to Serbian. */
export function marketingLangFromPathname(pathname: string | null | undefined): LangCode {
  if (!pathname) return 'sr';
  const m = pathname.match(/^\/(sr-cyrl|sr|en|ru|tr|de)(?:\/|$)/);
  if (m?.[1] && isLangCode(m[1])) return m[1];
  return 'sr';
}
